import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgeComponentVariantOptions
} from './constants'
import { minimalVariant } from './styled-components'

const BadgesComponent = forwardRef(
  (
    { size, variant, color, disabled = false, isDimmed = false, ...props },
    fowardedRef
  ) => {
    const Component = badgeComponentVariantOptions[variant] || minimalVariant
    return (
      <Component
        color={disabled ? 'disabled' : color}
        size={size}
        isDimmed={isDimmed}
        ref={fowardedRef}
        {...props}
      />
    )
  }
)

BadgesComponent.displayName = 'BadgesComponent'

BadgesComponent.propTypes = {
  size: PropTypes.oneOf(Object.values(badgeSizeOptions)),
  variant: PropTypes.oneOf(Object.keys(badgeComponentVariantOptions)),
  color: PropTypes.oneOf(Object.values(badgeColorOptions)),
  disabled: PropTypes.bool,
  isDimmed: PropTypes.bool
}

export default BadgesComponent
